import React from 'react';

import { faCircleExclamation } from '@fortawesome/pro-regular-svg-icons';

import Activity from './activity';

import type { MenuOptions, TaskConfig } from 'bundles/apex/activities/types';
import type { PendingReply, SendEmailConfig } from 'bundles/apex/activities/send_email/types';
import type { Parent, ParentOption } from 'bundles/crm/types';
import type { Activity as ActivityType } from 'bundles/apex/activities/types';
import { Empty } from '@buildoutinc/blueprint-react/ui/Empty';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

interface ActivityListProps {
  activities: ActivityType[];
  activityMenuOptions?: MenuOptions;
  aiEnabled?: boolean;
  currentParent?: Parent | Parent[];
  forUserId?: number;
  autoExpandEmails?: boolean;
  hideAfterReparenting?: boolean;
  isBackofficeAdmin?: boolean;
  showParents?: boolean | 'path';
  showPinned?: boolean;
  showRedesignModal?: boolean;
  showNeedsReply?: boolean;
  subjectName?: string;
  tagText?: string;
  sendEmail?: SendEmailConfig;
  taskConfig?: TaskConfig;
  timeline?: boolean;
  resumeReply?: PendingReply | null;
  options?: {
    parents?: ParentOption[];
  }
  onDelete: (activity: ActivityType) => void;
  onResumeConsumed?: () => void;
  onSave: (activity: ActivityType) => void;
  onTogglePin?: (activity: ActivityType) => void;
}

export default function ActivityList({ activities, activityMenuOptions, ...props }: ActivityListProps) {
  if (activities.length === 0) {
    return (
      <Empty className="bg-white">
        <Empty.Media>
          <FontAwesomeIcon icon={faCircleExclamation} />
        </Empty.Media>
        <Empty.Title>No Activities to Display</Empty.Title>
      </Empty>
    );
  }

  return (
    <div className="d-flex flex-column">
      {activities.map(activity => (
        <Activity
          {...props}
          activity={activity}
          key={activity.id}
          menuOptions={activityMenuOptions}
        />
      ))}
    </div>
  );
}
